import { v4 as uuid } from "uuid";
import { RandomStringID } from "./RandomStringID";
export const UpdateExistingCustomerFinalRes = (state) => {

    const { uniqueId, comment, ReDownloadAttachmentData, rtl, lang } = state;

    const dir = rtl ? "right" : "left";
    const time = new Date();
    const ds = time.toISOString().replace(/[^0-9]/g, "").slice(0, 14);
    const randomID = RandomStringID(32, "aA#");
    const createId = uuid()
    const ID = createId.replaceAll(/-/g, "").toUpperCase();
    const UUID = createId;
    const leadId = state.setQueryData.extid

    const updateFinalResponse = {
        "MOBILY_BSL_SR": {
            "SR_HEADER": {
                "FuncId": "UpdateOpportunitySFA",
                "MsgVersion": "0001",
                "RequestorUserId": "ePortal",
                "RequestorChannelId": "ePortalUser",
                "ChannelTransactionId": `SR_${ds}`,
                "SrDate": ds,
            },
            "OpportunityReq": {
                "Envelope": {
                    "Body": {
                        "LeanLeadReplicationBulkReplicateRequest": {
                            "MessageHeader": {
                                "ID": ID,
                                "UUID": UUID,
                                "CreationDateTime": time.toISOString(), // system date
                                "ExistingCustomer": "Y", //This Flag is created for EAI identify between the existing and new customer as the input parameters are different in both cases.
                                "SenderBusinessSystemID": "", //Static
                                "RecipientBusinessSystemID": "", //Static
                                "SenderParty": {
                                    "InternalID": "" //Static
                                },
                                "RecipientParty": {
                                    "InternalID": "" //Static
                                }
                            },
                            "LeanLeadReplicateRequestMessage": {
                                "MessageHeader": {
                                    "UUID": UUID
                                },
                                "LeanLead": {
                                    "ID": leadId,
                                    "ProcessingTypeCode": "LEAD",
                                    "Status": {
                                        "UserStatusCode": "ZK",
                                    },
                                    "TextCollection": {
                                        "Text": {
                                            "TypeCode": "10001",
                                            "ContentText": {
                                                "Comments": comment,
                                                "languageCode": lang.toUpperCase(),
                                            },
                                        },
                                    },
                                }
                            }
                        }
                    }
                }
            },
            "AttachmentReq": {
                "Envelope": {
                    "Header": "",
                    "Body": {
                        "AttachmentFolderBulkReplicateRequest": {
                            "MessageHeader": {
                                "ID": ID,
                                "UUID": UUID,
                                "CreationDateTime": time.toISOString(),
                                "SenderBusinessSystemID": "", //Static
                                "RecipientBusinessSystemID": "", //Static
                                "SenderParty": {
                                    "InternalID": "" //Static
                                },
                                "RecipientParty": {
                                    "InternalID": "" //Static
                                }
                            },
                            "AttachmentFolderReplicateRequestMessage": {
                                "BasicMessageHeader": {
                                    "UUID": UUID
                                },
                                "AttachmentFolder": {
                                    "HostObjectReference": {
                                        "ObjectTypeCode": "64", //Static
                                        "ObjectID": leadId //lead ID
                                    },
                                    "Document": ReDownloadAttachmentData
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return updateFinalResponse;
}